import { makeStyles } from '@material-ui/core/styles';
import tw from 'twin.macro';

const borderRadius = '1rem';
export default makeStyles({
  root: {
    borderRadius,
    borderTopRightRadius: (props) => (props.noRightBorder ? '0' : undefined),
    borderBottomRightRadius: (props) => (props.noRightBorder ? '0' : undefined),
    borderWidth: (props) => (props.noBorderWidth ? '0' : '1px'),
    borderTopLeftRadius: (props) => (props.noLeftBorder ? '0' : undefined),
    borderBottomLeftRadius: (props) => (props.noLeftBorder ? '0' : undefined),
    height: '100%',
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': {
      borderRadius,
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      '@media (min-width: 768px)': {
        borderTopRightRadius: (props) => (props.noRightBorder ? '0' : undefined),
        borderBottomRightRadius: (props) => (props.noRightBorder ? '0' : undefined),
        borderTopLeftRadius: (props) => (props.noLeftBorder ? '0' : undefined),
        borderBottomLeftRadius: (props) => (props.noLeftBorder ? '0' : undefined),
      },
    },
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] .MuiAutocomplete-input': {
      ...tw`py-3`,
      'min-height': '26px',
    },
    '& .MuiFilledInput-underline:after': tw`border-0`,
    '& .MuiFormControl-root': tw`bg-transparent`,
  },
  input: (props) => ({
    '&': {
      ...(props.inputBgColor ? props.inputBgColor : tw`bg-white`),
      ...tw`flex items-center relative border border-gray-500 border-opacity-10 px-2 w-full h-full`,
      'font-family': 'var(--fontFamilyBody)',
      color: 'var(--searchInputTextColorHex, #1a202c)',
    },
    '&::placeholder': { ...tw`placeholder-gray-500`['::placeholder'], opacity: '1' },
    '&:before': tw`border-0`,
  }),
  inputRoot: (props) => ({
    '&:hover, &:focus, &:active': props.inputBgColor ? props.inputBgColor : tw`bg-white`,
    '&': {
      ...(props.inputBgColor ? props.inputBgColor : tw`bg-white`),
      ...tw`py-3`,
      'font-family': 'var(--fontFamilyBody)',
    },
    '&.Mui-disabled': props.inputBgColor ? props.inputBgColor : tw`bg-white`,
    '&.MuiFilledInput-root.Mui-focused': props.inputBgColor ? props.inputBgColor : tw`bg-white`,
  }),
  popper: {
    '&': tw`rounded-2xl pt-1`,
    minWidth: (props) => props.minWidth,
  },
  paper: (props) => ({
    '&': { ...tw`rounded-2xl p-2`, ...(props.inputBgColor || {}) },
    marginTop: 'unset',
    borderTopLeftRadius: 'unset',
    borderTopRightRadius: 'unset',
  }),
  groupLabel: (props) => props.inputBgColor,
});
